export const API_BASE_URL = process.env.REACT_APP_SERVER_URL || 'https://traverser-api.tride.live';
